<template>
  <div>
    <v-card class="ma-0">
      <v-card-title>
        Ingredient
        <!--<v-spacer></v-spacer>
        <v-icon color="primary" :disabled="UsedInRecipes().length > 0"
          >mdi-delete-outline</v-icon
        >-->
      </v-card-title>
      <v-card-text>
        <v-text-field
          class="pt-2 body-2 font-weight-bold"
          outlined
          dense
          label="Name"
          v-model="editedItem.name"
          @change="IsValid()"
          :rules="[rules.notEmpty]"
          hint="The name of the ingredient"
        ></v-text-field>
        <v-text-field
          class="body-2"
          outlined
          dense
          label="Weight"
          @change="UpdateKgPrice()"
          v-model="editedItem.weight"
          suffix="Kg"
          :rules="[rules.notNegative]"
          hint="The weight of the ingredient"
        ></v-text-field>
        <v-text-field
          class="body-2"
          outlined
          dense
          label="Price"
          @change="UpdateKgPrice()"
          v-model="editedItem.price"
          prefix="R"
          :rules="[rules.notNegative]"
          hint="The price of the ingredient"
        ></v-text-field>
        <v-text-field
          class="body-2"
          dense
          filled
          v-model="editedItem.kgPrice"
          prefix="R"
          suffix="per kilogram"
          readonly
        ></v-text-field>
        <div>Used in the following recipe(s)</div>
        <v-card max-height="300">
          <v-card-text>
            <v-treeview
              dense
              item-text="name"
              item-key="keyValue"
              open-all
              :items="UsedInRecipes()"
            >
              <template v-slot:prepend="{ item }">
                <v-icon>{{ GetIcon(item.itemType) }}</v-icon>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-progress-circular
          v-if="saving"
          :indeterminate="saving"
          size="24"
          color="primary"
          class="pl-3"
        ></v-progress-circular>
        <span class="caption pa-3">{{ savingStatus }}</span>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="primary"
          :disabled="!isDirty || saving || !isValid"
          @click="Save()"
          >Save</v-btn
        >
        <v-btn small color="primary" :disabled="saving" @click="Cancel()"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Ingredient",
  props: ["editedItem", "editedIndex"],
  computed: {
    ...mapState(["saving", "savingStatus", "ingredients"])
  },
  data: () => ({
    isDirty: false,
    isValid: false,
    rules: {
      notNegative: v =>
        parseFloat(v) >= 0 ||
        "Value must be numbers only and cannot be negative",
      notEmpty: v => v != "" || "Value cannot be empty"
    }
  }),
  methods: {
    IsValid() {
      this.isValid =
        parseFloat(this.editedItem.price) >= 0 &&
        parseFloat(this.editedItem.weight) >= 0 &&
        this.editedItem.name;
      this.isDirty = true;
    },
    EditRecipe(item) {
      this.$emit("RecipeClicked", item.key);
    },
    UsedInRecipes(keyValue = this.editedItem.keyValue) {
      let tmp = this.$store.getters.UsedInRecipes(keyValue);
      let items = [];

      if (tmp.length > 0)
        tmp.forEach(x => {
          let item = x;
          const kids = this.UsedInRecipes(x.keyValue);

          if (kids.length > 0) item.children = kids;
          items.push(item);
        });

      return items;
    },
    GetIcon(itemType) {
      let a = "";
      if (itemType === "ingredient") {
        a = "mdi-spoon-sugar";
      } else if (itemType === "recipe") a = "mdi-baguette";
      else a = "mdi-package-variant";
      return a;
    },
    Cancel() {
      this.$emit("Cancel");
    },
    async Save() {
      this.editedIndex = await this.$store.dispatch(
        "SaveIngredient",
        this.editedItem
      );

      let message = "Ingredient saved successfully";

      if (this.UsedInRecipes().length > 0) {
        let affectedRecipes = await this.$store.dispatch(
          "UpdateAffectedRecipes",
          this.editedItem
        );

        affectedRecipes = await this.$store.dispatch(
          "SaveRecipes",
          affectedRecipes
        );

        message +=
          " and updated " + affectedRecipes.length + " affected recipe(s)";
      }

      this.$store.dispatch("ShowAlert", {
        type: "success",
        message: message,
        timeout: 2500
      });
      this.isDirty = false;
      this.$emit("Save");
    },
    UpdateKgPrice() {
      this.editedItem.kgPrice = (
        parseFloat(this.editedItem.price) / parseFloat(this.editedItem.weight)
      ).toFixed(2);

      if (isNaN(this.editedItem.kgPrice)) this.editedItem.kgPrice = 0;

      this.isDirty = true;
      this.IsValid();
    }
  }
};
</script>
<style scoped>
.v-card {
  display: flex !important;
  flex-direction: column;
}
.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>
